export default __webpack_public_path__ + "static/UniversalPre-KindergartenPrograms-2113e9269ab58445dc0b55d6da5f4143.jpg";